import { buttonVariants } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

export function Hero() {
  return (
    <section
      id="home"
      className="relative overflow-hidden bg-gradient-to-br from-brand-navy via-brand-navy-light to-brand-navy scroll-mt-16"
    >
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(193,39,45,0.15),transparent_50%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,rgba(25,54,97,0.3),transparent_50%)]" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <Badge
              variant="secondary"
              className="mb-6 bg-white/15 text-white border-white/20 backdrop-blur-sm hover:bg-white/20 text-sm px-4 py-1.5"
            >
              AI-Powered Healthcare Documentation
            </Badge>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white leading-[1.1] mb-6">
              Intelligent Medical Scribe for Your{" "}
              <span className="font-script text-brand-red-light text-5xl sm:text-6xl lg:text-7xl">
                Entire Care Team
              </span>
            </h1>

            <p className="text-lg sm:text-xl text-white/80 leading-relaxed mb-8 max-w-xl">
              ConsultNow automates clinical documentation across your provider
              network. Real-time AI transcription, team collaboration, and
              seamless EHR integration — so your clinicians can focus on
              patients.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="#demo"
                className={cn(
                  buttonVariants({ size: "lg" }),
                  "bg-brand-red hover:bg-brand-red-dark text-white font-semibold shadow-lg shadow-brand-red/30 text-base px-8 h-12"
                )}
              >
                Request a Demo <ArrowRight className="ml-2 h-4 w-4" />
              </a>
              <a
                href="#features"
                className={cn(
                  buttonVariants({ variant: "outline", size: "lg" }),
                  "border-2 border-white/30 text-white hover:bg-white/10 backdrop-blur-sm bg-transparent font-semibold text-base px-8 h-12"
                )}
              >
                See How It Works
              </a>
            </div>

            <p className="mt-10 text-sm text-white/50 font-medium">
              Trusted by 500+ healthcare providers
            </p>
          </div>

          <div className="flex items-center justify-center">
            <div className="relative w-full">
              <div className="rounded-2xl overflow-hidden shadow-2xl shadow-black/40 border border-white/10">
                <img
                  src="/screenshots/encounters-list.png"
                  alt="ConsultNow encounters dashboard showing patient encounters, types, and clinical details"
                  className="w-full h-auto"
                />
              </div>
              <div className="absolute -bottom-6 -left-6 w-28 sm:w-36 rounded-xl overflow-hidden shadow-xl shadow-black/30 border-2 border-white/20 hidden md:block">
                <img
                  src="/screenshots/mobile-encounters.png"
                  alt="ConsultNow mobile view"
                  className="w-full h-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
